import { coreAnonymousPost, coreGet, coreMutate } from "./api-client";

export interface AuthenticatedWorkspace {
  id: string;
  code: string;
  name: string;
  workspaceType: string;
  status: string;
  membershipStatus: string;
}

export interface WorkspaceSelection {
  workspaces: AuthenticatedWorkspace[];
  selectedWorkspaceId: string | null;
}

export interface AuthenticatedIdentity {
  user: {
    id: string;
    username: string | null;
    primaryEmail: string | null;
    displayName: string;
    administratorType: "NORMAL_ADMIN" | "SUPER_ADMIN";
    status: string;
  };
}

export interface FutureceedSsoStatus {
  enabled: boolean;
}

export interface AccountPasswordAuthStatus {
  enabled: boolean;
}

export function loadAuthenticatedWorkspaces(signal?: AbortSignal) {
  return coreGet<WorkspaceSelection>("/auth/workspaces", signal);
}

export function loadAuthenticatedIdentity(signal?: AbortSignal) {
  return coreGet<AuthenticatedIdentity>("/auth/me", signal);
}

export function loadFutureceedSsoStatus(signal?: AbortSignal) {
  return coreGet<FutureceedSsoStatus>("/auth/futureceed/status", signal);
}

export function loadAccountPasswordAuthStatus(signal?: AbortSignal) {
  return coreGet<AccountPasswordAuthStatus>("/auth/password/status", signal);
}

export function loginLocalUatPassword(username: string, password: string) {
  return coreAnonymousPost<{ authenticated: true; redirectTo: "/inquiries" }>(
    "/auth/local-uat/password-login",
    { username, password },
  );
}

export function loginAccountPassword(username: string, password: string) {
  return coreAnonymousPost<{ authenticated: true; redirectTo: "/" }>(
    "/auth/password/login",
    {
      username,
      password,
    },
  );
}

export function logoutAuthenticatedSession() {
  return coreMutate<{ revoked: true }>("/auth/logout", "POST", {});
}

export function selectAuthenticatedWorkspace(workspaceId: string) {
  return coreMutate<{ selected: true; workspace: AuthenticatedWorkspace }>(
    "/auth/workspace/select",
    "POST",
    { workspaceId },
  );
}
